var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_643_9066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.61865 16C4.20728 16 0.618652 12.4114 0.618652 8C0.618652 3.58862 4.20728 0 8.61865 0C13.03 0 16.6187 3.58862 16.6187 8C16.6187 12.4114 13.03 16 8.61865 16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1193 7.33325H9.28589V4.49988C9.28589 4.13185 8.98729 3.83325 8.61926 3.83325C8.25123 3.83325 7.95264 4.13185 7.95264 4.49988V7.33325H5.11926C4.75123 7.33325 4.45264 7.63185 4.45264 7.99988C4.45264 8.36791 4.75123 8.6665 5.11926 8.6665H7.95264V11.4999C7.95264 11.8679 8.25123 12.1665 8.61926 12.1665C8.98729 12.1665 9.28589 11.8679 9.28589 11.4999V8.6665H12.1193C12.4873 8.6665 12.7859 8.36791 12.7859 7.99988C12.7859 7.63185 12.4873 7.33325 12.1193 7.33325Z",
    fill: "#3E64F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_643_9066"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.618652 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddIcon);
export default __webpack_public_path__ + "static/media/Add-icon.2923df03c8e052c98183b78ca06c508e.svg";
export { ForwardRef as ReactComponent };